
import { v4 as uuidv4 } from 'uuid';
export default function TodoReducer(currentState,action){
    switch(action.type){
        case("added"):{
            const newTodo = {
            id:uuidv4(),
            title:action.payload.title,
            content:'',
            isCompleted:false,
            };
            const updateTodos=[...currentState , newTodo];
            
            localStorage.setItem("todos", JSON.stringify(updateTodos));

            return updateTodos;
        }
        case("deleted"):{
            const updateTodo = currentState.filter((t) => {
            return  t.id !== action.payload.id; 
            });
            localStorage.setItem("todos", JSON.stringify(updateTodo));
            return updateTodo;
        }
        case("edit"):{
            const updateList = currentState.map((t)=>{
                return t.id === action.payload.id ? {...t,title:action.payload.title, content:action.payload.content}:t;
            });
            
            localStorage.setItem("todos", JSON.stringify(updateList));
            return updateList;
        }
        case("get"):{
            let storageList=JSON.parse(localStorage.getItem("todos"))|| [];
        
            return storageList;
        }
        case("completed"):{
            const updateTodo = currentState.map((t) => {
                return  t.id === action.payload.id ? { ...t, isCompleted: !t.isCompleted } : t
            });
            localStorage.setItem("todos", JSON.stringify(updateTodo));
            return updateTodo
        }


        default:{
            
            throw Error("The Type unknown" + action.type);
        }
    };
    
}